import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import store from './reduxStore'
import { Provider } from 'react-redux'
import 'antd/dist/antd.css'
require('dotenv').config()


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
